import { UnitService } from './../../../_services/unit.service';
import { DivisionService } from './../../../_services/division.service';
import { DesignationService } from './../../../_services/designation.service';
import {
  Component,
  OnInit,
  ElementRef,
  Input,
  ViewChild,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalService } from '../../../_services/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PaginationInfo } from '../../../_models/pagination-info';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ResponseStructure } from '@iq-central-front-end/share';
import { DepartmentService } from '../../../_services/department.service';
import { StaffService } from '../../../_services/staff.service';
import { CourseService } from '../../../_services/course.service';
import { DomSanitizer } from '@angular/platform-browser';
import {
  DashboardFilter,
  InitialDashboardFilter,
} from '../../../interfaces/dashboard.interface';
import Swal from 'sweetalert2';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'iq-central-front-end-staff-details',
  templateUrl: './staff-details.component.html',
  styleUrls: ['./staff-details.component.scss'],
})
export class StaffDetailsComponent implements OnInit, AfterViewInit, OnDestroy {
  isUnassigning: boolean = false;
  @ViewChild('edit') edit: ElementRef;
  active: boolean;
  staff;
  profileEditForm: FormGroup;
  messageForm: FormGroup;
  sub: Subscription = new Subscription();
  tags;
  courses: any[] = [];
  enrolledCourses: any[] = [];
  learningPath: any[] = [];
  staffId;
  CoursePaginationInfo: PaginationInfo;
  file: any;
  requiredFileType: boolean;
  learningPathPaginationInfo: PaginationInfo;
  enrolledCoursePagination: PaginationInfo;
  departments: any[] = [];
  designations: any[] = [];
  divisions: any[] = [];
  units: any[] = [];
  courseResult: string;
  courseCode: string;
  userDatils: any;
  mentorId: any;

  filterQuery: DashboardFilter = { ...InitialDashboardFilter };

  @Input() id: string;
  private element: any;
  @ViewChild('editModal') editModal: ElementRef;

  constructor(
    private _global: GlobalService,
    private _activatedRoute: ActivatedRoute,
    private _staffService: StaffService,
    private _formBuilder: FormBuilder,
    private _departmentService: DepartmentService,
    private _designationService: DesignationService,
    private _division: DivisionService,
    private _unit: UnitService,
    private _course: CourseService,
    private sanitizer: DomSanitizer,
    private el: ElementRef,
    private router: Router
  ) {
    this.element = el.nativeElement;
  }

  ngAfterViewInit(): void {
    if (this._activatedRoute.snapshot.paramMap.get('edit')) {
      this.openEdit();
    }
  }

  ngOnInit(): void {
    this.userDatils = JSON.parse(localStorage.getItem('userDetails'));
    this.mentorId = this.userDatils.user_id;
    this.getResolvedData();
    this.initialProfileForm();
    this.initMessageForm();
    this.getAllDepartments();
    this.getAllDesignations();
    this.staffId = this._activatedRoute.snapshot.params['id'];
  }

  getResolvedData() {
    this.sub.add(
      this._activatedRoute.data.subscribe((response) => {
        this.staff = response['resolvedData'].staffDetails['responseResult'];

        this.courses =
          response['resolvedData'].courses['responseResult'].assignedCourses;
        this.CoursePaginationInfo =
          response['resolvedData'].courses['responseResult'].paginationInfo;
        this.learningPath =
          response['resolvedData'].learningPath['responseResult'].learningPaths;
        this.learningPathPaginationInfo =
          response['resolvedData'].learningPath[
            'responseResult'
          ].paginationInfo;
        this.enrolledCourses =
          response['resolvedData'].enrolledCourses['responseResult'].courses;
        this.enrolledCoursePagination =
          response['resolvedData'].enrolledCourses[
            'responseResult'
          ].paginationInfo;
        this.active = this.staff['active'];
      })
    );
  }

  sanitizeUrl(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  openEdit() {
    this.edit.nativeElement.click();
  }
  downloadResult() {
    // let resultPdf = new jsPDF();
    // let section= document.getElementById('content');
    // let page= function() { resultPdf.save('pagename.pdf'); };
    // // resultPdf.save(`${this.enrolledCourses}${'.pdf'}`);
    // // resultPdf.addHTML(section,page);
    // resultPdf.text('Hello', 10, 10);
    // resultPdf.save('a.pdf');
  }

  navigateCoursePage(page) {
    this._global.showSpinner();
    this._staffService.getAssignedCourses(page, 5).subscribe({
      next: (response) => {
        this._global.hideSpinner();
        this.courses = response['responseResult'].assignedCourses;
        this.CoursePaginationInfo = response['responseResult'].paginationInfo;
      },
    });
  }

  navigateLearningPage(page) {
    this._staffService.getAssignedLearningPath(page, 5).subscribe({
      next: (response) => {
        this.learningPath = response['responseResult'].learningPaths;
        this.learningPathPaginationInfo =
          response['responseResult'].paginationInfo;
      },
    });
  }

  navigateEnrolledCoursePage(page) {
    this._course.enrolledCourses(page, 6).subscribe({
      next: (response) => {
        this.enrolledCourses = response['responseResult'].assignedCourses;
        this.enrolledCoursePagination =
          response['responseResult'].paginationInfo;
      },
    });
  }

  initialProfileForm() {
    this.profileEditForm = this._formBuilder.group({
      departmentId: [this.staff?.department?.id],
      designationId: [this.staff?.designation?.id],
      isAdmin: [this.staff?.isAdmin],
      unitId: [this.staff?.unit?.id],
      divisionId: [this.staff?.division?.id],
      employmentNumber: [this.staff?.employmentNumber],
      fullName: [this.staff?.user.fullName],
      phoneNumber: [this.staff?.user.phoneNumber],
      username: [{ value: this.staff?.user.username, disabled: true }],
    });

    if (!this.staff?.isAdmin) {
      this.profileEditForm.disable();
      this.profileEditForm.get('phoneNumber').enable();
    }
  }
  initMessageForm() {
    this.messageForm = this._formBuilder.group({
      subject: [''],
      content: ['', Validators.required],
    });
  }

  updateProfile() {
    const updatedInfo = this.profileEditForm.value;
    console.log(updatedInfo);
    this._global.showSpinner();
    this._staffService
      .updateOneEnterpriseUser(updatedInfo, this.staffId)
      .subscribe({
        next: (res: ResponseStructure) => {
          this._global.successHandlerWithObject(res);
        },
      });
  }

  activateDeactivateProfile() {
    this.sub.add(
      this._staffService.toggleActivateDeactivateStaff(this.staffId).subscribe({
        next: (res: ResponseStructure) => {
          this.active = !this.active;
          this._global.globalSuccessHandler(res);
        },
      })
    );
  }

  getAllDepartments() {
    this._departmentService.getAllDepartments(this.filterQuery).subscribe({
      next: (response) => {
        this.departments = response['responseResult'];
      },
    });
  }
  getAllDesignations() {
    this._designationService.getAllDesignations().subscribe({
      next: (response) => {
        // ;
        this.designations = response['responseResult'];
      },
    });
  }

  getDivisions(departmentId) {
    this._division.getAllDivisionsByDepartment(departmentId).subscribe({
      next: (response) => {
        this.divisions = response['responseResult'];
      },
    });
  }
  getUnits(divisionId) {
    this._unit.getAllUnitsByDivision(divisionId).subscribe({
      next: (response) => {
        this.units = response['responseResult'];
      },
    });
  }

  sendMessage() {
    this._global.showSpinner();
    const payload = this.messageForm.value;
    this.sub.add(
      this._staffService.sendMessage(payload, this.staff.id).subscribe({
        next: (res: ResponseStructure) => {
          this._global.globalSuccessHandler(res);
        },
      })
    );
  }

  getFile(event, id) {
    this.file = event[0];
    if (this.file) {
      const extension = this.file.name.split('.')[1].toLowerCase();
      if (
        'png'.toLowerCase() !== extension.toLowerCase() &&
        'jpg'.toLowerCase() !== extension.toLowerCase() &&
        'jpeg'.toLowerCase() !== extension.toLowerCase()
      ) {
        this.requiredFileType = true;
        console.log(this.requiredFileType);
      } else {
        if (id) {
          this.uploadStaffAvatar(this.file, id);
        } else {
          this.uploadAvatar(this.file);
        }
      }
    }
  }

  uploadAvatar(file) {
    this._global.showSpinner();
    const formData = new FormData();
    formData.append('avatar', file);
    this.sub.add(
      this._staffService.uploadAvatar(formData).subscribe({
        next: (res: ResponseStructure) => {
          this._global.success();
          this.file = '';
          this.requiredFileType = false;
        },
      })
    );
  }
  uploadStaffAvatar(file, staffId) {
    this._global.showSpinner();
    const formData = new FormData();
    formData.append('avatar', file);
    this.sub.add(
      this._staffService.uploadStaffAvatar(formData, staffId).subscribe({
        next: (res: ResponseStructure) => {
          this.staff.user.avatarUrl = res.responseResult;

          this._global.success();

          this.file = '';
          this.requiredFileType = false;
        },
      })
    );
  }
  confirmation(courseItem?: any) {
    Swal.fire({
      title: 'Are you sure?',
      text: `This course will be unassigned from ${this.staff.user.fullName}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#1CB4AE',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Delete',
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        this.isUnassigning = true;

        try {
          await this._course
            .unassignCourse({
              code: courseItem.course.code,
              id: this.staff?.user?.id,
            })
            .toPromise();
          return true;
        } catch (error) {
          this.isUnassigning = true;

          Swal.showValidationMessage(
            `Request failed: ${error?.message || error}`
          );
          return false;
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      this.isUnassigning = true;

      if (result.isConfirmed) {
        Swal.fire('Unassigned!', 'The course has been removed.', 'success');
        this._global.hideSpinner();

        // Optional: Refresh route
        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => {
            this.router.navigate([this.router.url]);
          });
      }
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
